import React from "react";
import { Chip, Tooltip } from "@mui/material";
import type { IntegrationAttemptDto } from "client/api-v2";
import { IntegrationAttemptStatus } from "client/api-v2";

export function IntegrationAttemptStatusChip({ attempt }: { attempt: IntegrationAttemptDto }) {
  if (attempt.status === IntegrationAttemptStatus.Succeeded) {
    return <Chip label="Succeeded" size="small" color="success" variant="outlined" />;
  }

  if (attempt.status === IntegrationAttemptStatus.Failed) {
    return <Chip label="Failed" size="small" color="error" variant="outlined" />;
  }

  return attempt.isStuck ? (
    <Tooltip title="This attempt was started and never came back.">
      <Chip label="Stuck" size="small" color="warning" variant="outlined" />
    </Tooltip>
  ) : (
    <Chip label="In progress" size="small" variant="outlined" />
  );
}
